export default "__VITE_ASSET__wDjWlWDI__"